export default __webpack_public_path__ + "locales/ro/Common.json?hash=bf70320dd8cd21a68f8387ceefca614a";